if (!customElements.get('bc-cart-shipping')) {
  class BlackcellCartShipping extends HTMLElement {
    connectedCallback() {
      this.onChange = this.onChange || this.refresh.bind(this);
      document.addEventListener('afterCartChanged', this.onChange);
      document.addEventListener('afterUpdateQuantity', this.onChange);
      document.addEventListener('afterDiscountUpdate', this.onChange);
    }
    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onChange);
      document.removeEventListener('afterUpdateQuantity', this.onChange);
      document.removeEventListener('afterDiscountUpdate', this.onChange);
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    refresh() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.timer = setTimeout(async () => {
        const controller = new AbortController();
        this.controller = controller;
        try {
          const url = new URL(this.dataset.root || '/', window.location.origin);
          url.searchParams.set('section_id', 'blackcell-cart-shipping');
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {signal: controller.signal, cache:'no-store'});
          if (!response.ok) throw new Error('Shipping section unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('bc-cart-shipping');
          if (!next || controller.signal.aborted || !this.isConnected) return;
          this.dataset.mode = next.dataset.mode;
          this.hidden = next.hidden;
          this.replaceChildren(...next.childNodes);
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }, 80);
    }
  }
  customElements.define('bc-cart-shipping', BlackcellCartShipping);
}
